<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" color="error" :top="true">{{ snackbar_message
    }}</v-snackbar>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4 mt-12>
        <v-card class="mt-12">
          <progress-bar :show="form.busy"></progress-bar>
          <form @submit.prevent="reset" @keydown="form.onKeydown($event)">
            <v-card-title primary-title>
              <h3 class="headline mb-0">{{ $t("reset_password") }}</h3>
            </v-card-title>
            <v-card-text>
              <!-- Email -->
              <div>
                <v-text-field autocomplete="current-password" :label="$t('email')" disabled type="email"
                  v-model="form.email" name="email" solo></v-text-field>
                <has-error :form="form" :field="form.email"></has-error>
              </div>

              <!-- Password -->
              <password-input ref="password" :form="form" :hint="$t('password_length_hint')" :v-errors="errors"
                :value.sync="form.password" v-on:eye="eye = $event" v-validate="'required|min:8'"></password-input>

              <!-- Password Confirmation -->
              <password-input :form="form" :hide="eye" :label="$t('confirm_password')" :v-errors="errors"
                :value.sync="form.password_confirmation" data-vv-as="password" hide-icon="true"
                name="password_confirmation" v-validate="'required|confirmed:password'"></password-input>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <submit-button :flat="true" :form="form" :label="$t('reset_password')"></submit-button>
              <v-spacer></v-spacer>
            </v-card-actions>
          </form>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Form from "vform";

export default {
  name: "reset-view",
  layout: "default",
  metaInfo() {
    return { title: this.$t("reset_password") };
  },

  data: () => ({
    form: new Form({
      token: "",
      email: "",
      password: "",
      password_confirmation: "",
    }),
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    eye: true,
  }),
  mounted() {
    this.form.email = this.$route.query.email;
  },
  methods: {
    async reset() {
      if (await this.formHasErrors()) return;

      if (!this.form.password || !this.form.password_confirmation) {
        this.snackbar = true
        this.snackbar_message =
          'Veuillez remplir tous les champs avant de poursuivre'
        return
      }
      this.form.token = this.$route.params.token;

      try {
        const response = await this.form.post("/api/password/reset");

        // Login user if reset successful.
        const { data } = await this.form.post("/api/auth/login");

        // Save the token.
        this.$store.dispatch("saveToken", {
          token: data.access_token,
          remember: true,
        });

        // Fetch the user.
        await this.$store.dispatch("fetchUser");

        this.form.reset();
        // Redirect home.
        this.$router.push({ name: "overview" });
      } catch (error) {
        this.$store.dispatch("responseMessage", {
          type: "red",
          text: error.response.data.errors.message,
        });
      }
    },
  },
  beforeDestroy() {
    this.$validator.pause();
  },
};
</script>
<style scoped>
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #78b943;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/password/reset.vue